import { Component, OnInit, NgZone } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { ProfileService } from '@data/services/profile.service';
import { User } from '@data/models/user';
import { Router, NavigationEnd } from '@angular/router';
import { SubSink } from 'subsink';
import { environment } from '@env/environment';
import { EncryptService } from '@core/services/encrypt.service';
import { encryptionKey } from '@shared/appConfig';
import { KeycloakService } from 'keycloak-angular';


// declare ga as a function to set and sent the events to google Analytics
declare let ga: Function;
@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements OnInit {
  localStorageService: LocalStorageService;
  openMobileSlider = false;
  private subs = new SubSink();
  profilePic = '';
  userLoggedIn = false;
  currentUser;
  session;
  env: any = environment;
  keyCloakObj: any;
  currentProfile;
  cProfile;
  selectedAccount;

  constructor(private authService: AuthService, private profile: ProfileService, private router: Router,
              private ngZone: NgZone, private encryptService: EncryptService, protected readonly keycloak: KeycloakService) {
    this.localStorageService = new LocalStorageService(this.profile);
    // subscribe to router events and send page views to Google Analytics
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga('create', environment.googleAnalyticsId, 'auto');
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
  }

  ngOnInit() {
    this.keycloak.isLoggedIn()
      .then((loginStatus) => this.getAccountInfoResponse(loginStatus))
      .catch((error) => { console.log('Failed to load user profile', error); });
    this.session = this.currentUser = JSON.parse(localStorage.getItem('session'));
    if (this.session != null) {
      this.userLoggedIn = true;
      if (typeof this.session.thumbnailURL != 'undefined' && this.session.thumbnailURL != '') {
        this.profilePic = this.session.thumbnailURL;
      } else {
        this.profilePic = "/assets/img/Default_Profile_Img.png";
      }
      
      this.currentProfile = JSON.parse(localStorage.getItem('profile'));
      
      this.cProfile = {
        name: this.currentProfile.FirstName + " " + this.currentProfile.LastName,
        street: this.currentProfile.BillingStreet_1,
        state: this.currentProfile.BillingState,
        city: this.currentProfile.BillingCity,
        country: this.currentProfile.BillingCountry,
        postalcode: this.currentProfile.BillingPostalCode,
        //street:this.currentProfile.MailingStreet,
        profile: true
      };
   }
    this.subs.add(this.profile.changeUserEvent.subscribe((result: any) => {
      if (result.AccountId) {
        this.ngZone.run(() => {
          if (typeof result.thumbnailURL != 'undefined') {
            this.profilePic = result.thumbnailURL;
          }

          this.userLoggedIn = true;
          if (!this.profilePic) {
            this.profilePic = "/assets/img/Default_Profile_Img.png";
          }
        });
        this.userLoggedIn = true;
        this.currentProfile = JSON.parse(localStorage.getItem('profile'));
      
        if(this.currentProfile){
          this.cProfile = {
            name: this.currentProfile.FirstName + " " + this.currentProfile.LastName,
            street: this.currentProfile.BillingStreet_1,
            state: this.currentProfile.BillingState,
            city: this.currentProfile.BillingCity,
            country: this.currentProfile.BillingCountry,
            postalcode: this.currentProfile.BillingPostalCode,
            //street:this.currentProfile.MailingStreet,
            profile: true
          };
        }
      }
    }));
  }

  getAccountInfoResponse(loginStatus) {
    if (loginStatus) {
      const profile = JSON.parse(localStorage.getItem('profile'));
      this.keyCloakObj = this.keycloak;




       


      if (profile !== null && (this.keyCloakObj._instance.subject !== profile.UID)) {
        var sourceApp = localStorage.getItem('sourceApp');
        localStorage.clear();
        localStorage.setItem('sourceApp',sourceApp);
        this.keycloak.logout();
      } else {

          this.authService.setUserSession();
      }
    } else {
        this.profile.currentProfile = new User();
        this.profile.profileUpdate();
    }
  }

  logout() {
 //   this.localStorageService.onLogoutResponse.bind(this);
    this.logoutUser();
 }

 public async logoutUser() {
  localStorage.removeItem('token');
  localStorage.removeItem('profile');
  localStorage.removeItem('session');
  localStorage.removeItem('missionaryGAUId');
  localStorage.removeItem('isMissionaryUser');
  localStorage.removeItem('isFinanceUser');
  localStorage.removeItem('isHQUser');
  localStorage.removeItem('isGAUEditor');
  localStorage.removeItem('loginProvider');
  localStorage.removeItem('userId');
  var sourceApp = localStorage.getItem('sourceApp');
  localStorage.clear();
  localStorage.setItem('sourceApp',sourceApp);
  this.profile.logout();
  await this.keycloak.logout(window.location.origin + '')
    .then((response) => {
      console.log('response', response);
    })
    .catch(() => {
      console.log('Failed to logout user');
    });
}

  public async redirectUserToLogin(url) {
    if (!this.session) {
      const redirectUrl = this.env.eventsAwanaUrl + url;
      await this.keycloak.login({
        redirectUri: redirectUrl,
      })
        .catch((err) => {
          console.log('err', err);
        });

    }
  }

routeToAwanaURL() {
  window.open(
    this.env.awanaUrl
  );
 }

 goToTop() {
  window.scrollTo(0, 0);
 }

}
